export default __webpack_public_path__ + "media/images/poste-fixe-new-bcb965fbb7f3dab696f52cc9be6f79dc.png";